<template>
  <v-container fluid grid-list-md py1 class="custom video_talento">
    <div>
      <file-pond
        ref="pond_video"
        :max-files="maxfiles"
        name="file"
        allow-process="false"
        instant-upload="false"
        allow-revert="false"
        allow-paste="false"
        max-parallel-uploads="1"
        :label-file-loading="$t('view.commons.filepond.labelFileLoading')"
        :label-file-processing="$t('view.commons.filepond.labelFileProcessing')"
        :label-file-processing-complete="$t('view.commons.filepond.labelFileProcessingComplete')"
        :label-tap-to-retry="$t('view.commons.filepond.labelTapToRetry')"
        :label-idle="$t('view.commons.filepond.labelidle')"
        :label-invalid-field="$t('view.commons.filepond.labelInvalidField')"
        :label-file-processing-aborted="$t('view.commons.filepond.labelFileProcessingAborted')"
        :label-tap-to-cancel="$t('view.commons.filepond.labelTapToCancel')"
        :label-file-load-error="$t('view.commons.filepond.labelFileLoadError')"
        :label-file-processing-error="$t('view.commons.filepond.labelFileProcessingError')"
        :label-file-type-not-allowed="$t('view.commons.filepond.labelFileTypeNotAllowed')"
        :label-max-file-size-exceeded="$t('view.commons.filepond.labelMaxVideoSizeExceeded')"
        :label-max-file-size="$t('view.commons.filepond.labelMaxVideoSize')"
        :label-max-total-file-size-exceeded="$t('view.commons.filepond.labelMaxTotalFileSizeExceeded')"
        :file-validate-type-label-expected-types="$t('view.commons.filepond.fileValidateTypeLabelExpectedTypes').replace(/{(\d+)}/g, 'video')"
        :label-button-download-item="$t('view.commons.filepond.labelButtonDownloadItem')"
        allow-file-size-validation="true"
        allow-multiple="false"
        allow-replace="false"
        allow-file-rename="true"
        drop-on-page="false"
        allow-download-by-url="true"
        accepted-file-types="video/mp4, video/webm, video/3gpp, video/x-matroska, video/x-m4v, video/quicktime"
        :files="myFiles"
        :server="{ process, revert }"
        :max-total-file-size="`${maxvideosize}MB`"
        :max-file-size="`${maxvideosize}MB`"
        :file-rename-function="rename"
        @warning="warning"
        @error="error"
        @addfile="validateVideoDuration"
        @removefile="removeFromFilePond" />
    </div>
  </v-container>
</template>
<script>
import removeAccents from "remove-accents";
import { EventBus } from "@/events/event-bus";
import * as events from "@/constants/event-names";
import { getDateWithFormat } from "@/helpers/date-methods";

export default {
  name: "TalentoVideo"
  , props: {
    talento: {
      default: undefined
      , type: Object
    }
    , maxvideosize: {
      default: 0
      , type: Number
    }
  }
  , data() {
    return { myFiles: [], maxfiles: "1" };
  }
  , methods: {
    process(_fieldName, file, _metadata, load, error, progress, abort) {
      try {
        // Construccion del formulario mock para request de subida de archivo
        const formData = new FormData();
        formData.append("file", file);
        formData.append("filename", file.name);

        // Construccion de request
        const request = new XMLHttpRequest();
        request.open("POST", "/api/bitacoraArchivos");
        request.setRequestHeader("Authorization", `Bearer ${this.$store.getters.getUserToken}`);
        request.upload.onprogress = (e) => {
          progress(e.lengthComputable, e.loaded, e.total);
        };

        request.onload = () => {
          this.mensajeErrorArchivo = "Ocurrió un error, intente nuevamente o compruebe sus permisos";
          if (request.status >= 200 && request.status < 300) {
            // the load method accepts either a string (id) or an object
            let response = JSON.parse(request.response);
            if (response.meta.code == "OK" && response.results) {
              let video = this.talento.video;
              video += video ? "," : "";
              video += `${response.results}:${file.name}:${file.size}:${file.type}:true:${getDateWithFormat("dd-MM-yyyy+hh-mm")}`;
              this.$emit("video", video);

              file.file = response.results;
              load(response.results);
            } else {
              error(response.results.error);
              EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", "Error al subir archivo");
            }
          } else {
            error("Ocurrió un error al subir el archivo");
          }
        };
        request.send(formData);

        // Should expose an abort method so the request can be cancelled
        return {
          abort: () => {
            request.abort();
            abort();
          }
        };
      } catch (error2) {
        console.error(error2);
      }
    }
    , async validateVideoDuration(err, fileItem) {
      if (err) {
        console.error("Ocurrió un error al subir el archivo:", err);
        return;
      }
      this.validateName(fileItem);
      const file = fileItem.file;

      if (file.type.startsWith("video/")) {
        const video = document.createElement("video");
        const objectURL = URL.createObjectURL(file);
        video.src = objectURL;

        video.onloadedmetadata = () => {
          if (video.duration > 300) {
            EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", "El vídeo excede la duración permitida (máximo 5 minutos)");
            this.$refs.pond_video.removeFile(fileItem.id);
          } else {
            this.addFileVideo();
          }
          URL.revokeObjectURL(objectURL); 
        };

        video.onerror = () => {
          console.error("Error al cargar el video para validación.");
          URL.revokeObjectURL(objectURL); 
        };
      }
    }
    , validateName(fileItem){
      const filename = fileItem.file.name;
      const invalids = ["\\","/", ":", "*", "?", "\"", "<", ">", "|"];

      const charinvalid = invalids.find(char => filename.includes(char));
      
      if (charinvalid){
        EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "warning", "VL0000", this.$t("view.commons.filepond.fileNameInvalid").replace(/{(.+?)}/g, charinvalid));
        this.$refs.pond_video.removeFile(fileItem.id); 
      }
    }
    , addFileVideo(error){
      if (!error){
        this.$emit("video", " ");
      }
    }
    , rename(file) {
      return removeAccents(file.name.replaceAll(" ", "_")).replace(/[^a-zA-Z_ .-@]/g, "");
    }
    , revert(uniqueFileId, load) {
      this.removeFromFilePond(uniqueFileId);
      load();
    },
    warning(error, file) {
      if ("Max files" == error.body) error.body = this.$t("view.commons.filepond.labelMaxFiles").replace(/{(\d+)}/g, this.maxfiles);
      if (error && error.type) EventBus.$emit(events.SHOW_TOASTER_MESSAGE, error.type, "VL0000", error.body);
      file.file.error = true;
      setTimeout(() => {
        this.$refs.pond_video.removeFile(file.id);
      }, 6000);
    }
    , error(error, file) {
      if ("Max files" == error.body) error.body = this.$t("view.commons.filepond.labelMaxFiles").replace(/{(\d+)}/g, this.maxfiles);
      if (error && error.type) EventBus.$emit(events.SHOW_TOASTER_MESSAGE, error.type, "VL0000", error.body);
      file.file.error = true;
      setTimeout(() => {
        this.$refs.pond_video.removeFile(file.id);
      }, 6000);
    }
    , removeFromFilePond(id) {
      this.myFiles = this.removeAttachmentFromList(id, this.myFiles);
      this.$emit("video", this.myFiles ? this.aplanarList(this.myFiles) : []);
    }
    , removeAttachmentFromList(id, list) {
      const index = list.findIndex((item) => item.source.includes(id));
      return [...list.slice(0, index), ...list.slice(index + 1)];
    }
    , aplanarList(list) {
      return list
        .map((item) => {
          const { file, name, size, type, priv, date } = item.options.file;
          return `${file}:${name}:${size}:${type}:${priv}:${date}`;
        })
        .join(",");
    }
  }
};
</script>

<style>
.video_talento.custom.container {
  padding: 10px 0 0 0;
  max-width: 100% !important;
}
.video_talento .filepond--root {
  min-height: 2em !important;
  margin-bottom: 0;
  font-size: 14pt !important;
}
.video_talento .removePermission .filepond--action-remove-item {
  display: none !important;
}

.filepond--file-info .filepond--file-info-main-container {
  display: flex;
  align-items: center;
}

.video_talento .filepond--panel-root {
  background-color: #e8e6e3;
  border: 3px dashed var(--v-primary-base);
}

.video_talento .filepond--item-panel {
  background-color: var(--v-primary-base) !important;
}

.video_talento [data-filepond-item-state*="error"] .filepond--item-panel,
[data-filepond-item-state*="invalid"] .filepond--item-panel {
  background-color: #c44e47 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/talento/TalentoVideo.vue